import { CodifyLogo, FacebookIcon, FooterColumn, FooterCopyright, FooterCredit, FooterIcons, FooterLogo, FooterSection, FooterWrapper, HomeButton, InstagramIcon, PolicyLink } from "./styled";
import Logo from "./logo_CMYK_biale.png"
import { ReactComponent as ArrowIcon } from "./arrow.svg";
import { useTranslation } from "react-i18next";
import { LINKS } from "../../config/links";

const Footer = () => {

    const { t, i18n } = useTranslation();
    const year = new Date().getFullYear();
    const policyPath = (i18n.resolvedLanguage || i18n.language)?.startsWith("en")
        ? "/privacy-policy"
        : "/polityka-prywatnosci";

    return (
        <FooterSection>
            <HomeButton to="home" smooth={true} duration={2000} offset={-90} aria-label={t("footer.backToTop")}>
                <ArrowIcon />
            </HomeButton>
            <FooterWrapper>
                <FooterLogo src={Logo} alt="Czorsztynianka logo" />

                <FooterColumn>
                    <FooterIcons>
                        <a
                            href={LINKS.facebook}
                            target="_blank"
                            title={t("footer.social.facebook")}
                            aria-label={t("footer.social.facebook")}
                            rel="noreferrer"
                        >
                            <FacebookIcon />
                        </a>

                        <a
                            href={LINKS.instagram}
                            target="_blank"
                            title={t("footer.social.instagram")}
                            aria-label={t("footer.social.instagram")}
                            rel="noreferrer"
                        >
                            <InstagramIcon />
                        </a>
                    </FooterIcons>
                    <PolicyLink
                        to={policyPath}
                    >
                        {t("footer.privacyLink")}
                    </PolicyLink>

                </FooterColumn>

                <FooterCopyright>

                    <span>{t("footer.copyright", { year })}</span>

                    <FooterCredit
                        href={LINKS.codify}
                        target="_blank"
                        rel="noopener noreferrer"
                        title="Codify"
                        aria-label="Codify"
                    >
                        <div>{t("footer.credit")}</div>
                        <div>
                            <CodifyLogo />
                        </div>
                    </FooterCredit>
                </FooterCopyright>
            </FooterWrapper>
        </FooterSection>
    );
};


export default Footer;